export default __webpack_public_path__ + "static/stretchme_icon-e805ece8c497a810d3e59bfc374f0659.png";